import { ca } from '@cian/analytics';

const DAILYRENT_BANNER_LABEL = 'dailyrent_banner';

// NOTE: названия событий взяты по аналогии с баннером в выдаче (frontend-serp), согласовать с аналитиками
export const trackDailyrentBannerShow = (postId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Magazine',
    action: 'show_sopr',
    label: DAILYRENT_BANNER_LABEL,
    page: { extra: { postId } },
  });
};

export const trackDailyrentBannerClick = (postId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Magazine',
    action: 'click',
    label: DAILYRENT_BANNER_LABEL,
    page: { extra: { postId } },
  });
};
